import { useQuery } from '@tanstack/react-query';

import { individualsService, Individual } from '@aslanpay/portal-common-lib';

export const fetchIndividualQuery = (id?: string, enabled = true) => ({
  queryKey: ['fetchIndividual', id],
  queryFn: async () => {
    const individual = await individualsService.fetchIndividual(id || '');
    const status =
      individual.status === 'ACTIVE' && individual.terminationDate ? 'LEAVING' : individual.status;

    return { ...individual, status };
  },
  enabled: !!id && enabled,
});

const useFetchIndividual = (id?: string, enabled = true) => {
  return useQuery<Individual, Error>(fetchIndividualQuery(id, enabled));
};

export default useFetchIndividual;
